<ng-container *ngIf="isLoginShowing">
    <div class="container-fluid g-0">
        <div style="width: 100vw" class="row">
            <div class="col-lg-12 col-sm-12 mx-auto d-flex justify-content-center auth">
                <mat-card class="auth-card mat-elevation-z2">
                    <form id="logInForm" [formGroup]="logInForm" (ngSubmit)="logInSubmit()">
                        <h1 class="auth-form-title">Sign Into DDJ</h1>
                        <mat-form-field appearance="fill">
                            <mat-label>Email</mat-label>
                            <mat-placeholder>Email</mat-placeholder>
                            <input class="form-control" type="email" matInput formControlName="email" />
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Password</mat-label>
                            <mat-placeholder>Password</mat-placeholder>
                            <input class="form-control" [type]="viewPassword ? 'text' : 'password'" matInput formControlName="password" />
                            <mat-icon *ngIf="!viewPassword" matSuffix (click)="passwordVisible()" class="my-icon">visibility</mat-icon>
                            <mat-icon *ngIf="viewPassword" matSuffix (click)="passwordVisible()" class="my-icon">visibility_off</mat-icon>
                        </mat-form-field>
                        <button class="mt-4 auth-form-submit" mat-flat-button type="submit" color="primary">Sign in</button>
                    </form>
                </mat-card>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="isVerifyShowing">
    <enter-verification (verify$)="verifyChange($event)" [phone]="phone"></enter-verification>
</ng-container>

<ddj-spinner *ngIf="isLoading"></ddj-spinner>
